import getRuntimeConfig from '@utils/getRuntimeConfig';

export const DevEnvironments = ['chris-dev', 'jakub-dev', 'klaudia-dev', 'tomek-dev', 'karol-dev'];

export const isTestingEnvironment = () =>
  ['aws-qa', 'aws-dev', ...DevEnvironments].includes(getRuntimeConfig('ENVIRONMENT_NAME'));
